import * as React from 'react'

import type { DiagnosticEntry } from '@modules/diagnostics/store'
import {
  getDiagnostics,
  isDiagnosticsEnabled,
  subscribeDiagnostics,
} from '@modules/diagnostics/store'

/**
 * 診断の記録を購読する。記録が増減したときだけ再レンダリングする。
 *
 * ストアは記録のたびに配列を作り替えるので、`useSyncExternalStore` の
 * 「スナップショットが変わらない間は同じ参照」という要件を満たす。
 */
export const useDiagnostics = (): readonly DiagnosticEntry[] =>
  React.useSyncExternalStore(subscribeDiagnostics, getDiagnostics, getDiagnostics)

/**
 * 診断が有効かどうかを購読する。
 *
 * `isDiagnosticsEnabled()` をrenderの中で素に読むと、有効化のタイミング（いまはアプリの
 * providerのモジュールスコープで、最初のrenderより前）に暗黙に依存する。将来 `useEffect` へ
 * 移すと「記録はされるがパネルが出ない」形で静かに壊れるため、フラグも購読対象にしておく。
 */
export const useIsDiagnosticsEnabled = (): boolean =>
  React.useSyncExternalStore(subscribeDiagnostics, isDiagnosticsEnabled, isDiagnosticsEnabled)
